import { Link } from 'react-router-dom';
import type { HotEvent } from '@/mocks/events';
import { StatusBadge, CategoryTag, heatLevel } from '@/components/feature/EventBits';

export default function EventGridCard({ event }: { event: HotEvent }) {
  return (
    <Link
      to={`/event/${event.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
        <img
          src={event.cover}
          alt={event.coverAlt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3">
          <StatusBadge status={event.status} />
        </div>
        <span className="absolute right-3 top-3 flex h-7 min-w-[2.75rem] items-center justify-center rounded-md bg-foreground-950/55 px-2 text-xs font-semibold text-background-50 backdrop-blur-sm tabular-nums">
          {event.heat}°热
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2">
          <CategoryTag category={event.category} />
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-node-tree text-[11px]" /> {event.nodes.length} 节点
          </span>
        </div>
        <h3 className="mt-3 line-clamp-1 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {event.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{event.summary}</p>
        <div className="mt-4 flex items-end justify-between border-t border-background-200 pt-3">
          <div className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-time-line" />
            <span className="tabular-nums">更新 {event.updated.slice(5).replace('-', '/')}</span>
            <span className="ml-1 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-700">{heatLevel(event.heat)}</span>
          </div>
          <span className="flex items-center gap-1 text-sm font-medium text-primary-600 transition-all group-hover:gap-2">
            看时间轴 <i className="ri-arrow-right-line text-sm" />
          </span>
        </div>
      </div>
    </Link>
  );
}